import { Injectable, OnInit, Output, EventEmitter } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, Jsonp} from '@angular/http';
import { Subject, Subscription } from 'rxjs/Rx';
import {AuthService} from "./auth.service";
import { Router } from "@angular/router";


@Injectable()
export class SettingsService extends AuthService{

    private URLGetComissions = "manager/settings/commissions";
    private URLGetProductsPrice = "manager/settings/product-price";
    private URLGetTransportPrice = "manager/settings/postalcode/:code/transport-price";
    private CODE = ":code";
    constructor(public http: Http, public router: Router) { 
        super(http,router)
    }

    public getComissions() {
        return this.http.get(this.APIURL + this.URLGetComissions ,{headers: this.headers})
        .map((res: Response) => res.json()["response"]); 
    }

    public getProductsPrice() {
        return this.http.get(this.APIURL + this.URLGetProductsPrice ,{headers: this.headers})
        .map((res: Response) => res.json()["response"]); 
    }

    public getTransportPrice(postal_code: string) {
        let URLGetTransportPrice = this.URLGetTransportPrice.replace(this.CODE, postal_code);
        return this.http.get(this.APIURL + URLGetTransportPrice ,{headers: this.headers})
        .map((res: Response) => res.json()["response"]); 
    }

    
}


// WEBPACK FOOTER //
// ./src/app/injections/settings.service.ts